var _excluded = ["children", "tagName"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { styleguide, lightThemeObject } from "../../../styleguide";
var TextCallout2Wrapper = styled.div.withConfig({
  displayName: "TextCallout2__TextCallout2Wrapper",
  componentId: "sc-1bir8f0-0"
})(["color:var(--bui-text,", ");font-size:15px;font-family:", ";line-height:20px;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;"], lightThemeObject['--bui-text'], styleguide.font.family.regular);

var TextCallout2 = function TextCallout2(_ref) {
  var children = _ref.children,
      _ref$tagName = _ref.tagName,
      tagName = _ref$tagName === void 0 ? 'div' : _ref$tagName,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(TextCallout2Wrapper, _extends({
    as: tagName
  }, props), children);
};

TextCallout2.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The content of the component
   */
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.element, PropTypes.string, PropTypes.number]),

  /**
   * Type of HTML-tag output.
   */
  tagName: PropTypes.oneOfType([PropTypes.string, PropTypes.func])
} : {};
export default TextCallout2;
//# sourceMappingURL=TextCallout2.js.map